import request from "root/js/request";

const getEconomyOfShipmentsDynamicOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  ...rest
}) => {
  const response = await request({
    url: "ozon_analytics/posting_economy_dynamic/",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      ...rest,
    },
  });
  return response.data;
};

export { getEconomyOfShipmentsDynamicOzon };
